import cx from 'classnames';
import {
    astToHtml,
    defaultFilterAdditionalData,
    FilterAdditionalData,
    ShowPhotosAndVideos,
} from 'mk2/helpers/article_ast/filters';
import { cacheLast } from 'mk2/helpers/cache';
import { AST, ASTAdditionalDataFromServer, PhotoEntity, StrollerEntity } from 'mk2/schemas';
import React from 'react';
import styles from './StrollerDetailDescription.mscss';

interface OwnProps {
    stroller: StrollerEntity;
    description: AST;
    data: ASTAdditionalDataFromServer;
    photos: PhotoEntity[];
    isMobile: boolean;
}

type Props = OwnProps;

export default class StrollerDetailDescription extends React.Component<Props> {
    private articleAstToHtmlCache = cacheLast(true);

    public render() {
        const {
            stroller,
            description,
            data,
            photos,
            isMobile,
        } = this.props;

        // prepare article message body
        let bodyChunks: React.ReactChild[] = null;
        if (description) {
            const additionalData: FilterAdditionalData = {
                ...defaultFilterAdditionalData,
                sourceApp: 'stroller',
                renderLinksWithNofollow: false,
                photos,
                linkedObjects: data.linkedObjects,
                customStyles: {
                    photo: styles.StrollerDetailDescription__content__photo,
                    header2: styles.StrollerDetailDescription__content__allTextElements,
                    header3: styles.StrollerDetailDescription__content__allTextElements,
                    header4: styles.StrollerDetailDescription__content__allTextElements,
                    unorderedlist: cx(
                        styles.StrollerDetailDescription__content__allTextElements,
                    ),
                    paragraph: cx(
                        styles.StrollerDetailDescription__content__allTextElements,
                    ),
                    strollersChart: styles.StrollerDetailDescription__content__strollersChart,
                },
                showPhotosAndVideos: ShowPhotosAndVideos.EXCEPT_COVER,
                hasResponsiveImages: isMobile,

                isMobile,
            };
            bodyChunks = this.articleAstToHtmlCache(() => astToHtml(description, additionalData), description);
        }

        return (
            <div className={styles.StrollerDetailDescription}>
                {bodyChunks && <div className={styles.StrollerDetailDescription__content}>{bodyChunks}</div>}
            </div>
        );
    }
}
